import { Inject, Injectable, LOCALE_ID } from "@angular/core";


@Injectable({
  providedIn: 'root'
})

export class LocaleResolver  {

  constructor(@Inject(LOCALE_ID) private localeId: string) { }

  resolve(): string {
    return this.localeId;
  }
}